<section class="">
  <div class="mx-auto w-full max-w-[90rem] p-5 md:px-8">
    <div
      class="flex flex-col items-center justify-center gap-4 sm:flex-row sm:justify-between"
    >
      <h1 class="flex">Quality of Experience</h1>

      <div class="flex flex-wrap items-center justify-center gap-2">
        <div
          class="mt-1 flex h-14 items-center justify-center rounded-full bg-white px-4 pb-0.5 pt-2 lg:ml-2"
        >
          <app-toggle
            [(ngModel)]="showMockData"
            (ngModelChange)="toggleMockData($event)"
            [label]="
              showMockData ? 'Switch to Real Data' : 'Switch to Sample Data'
            "
            size="md"
            color="primary"
          >
          </app-toggle>
        </div>
        <app-analytics-time-selector
          (selectedOptionChange)="onChildSelectionChange($event)"
        />
      </div>
    </div>

    @if (!isNoContent && !loading) {
      <mat-grid-list
        cols="5"
        rowHeight="400px"
        gutterSize="20px"
        class="my-4 gap-x-4"
      >
        <mat-grid-tile colspan="3">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="loading"
            class="h-full w-full"
          >
            <qoe-by-time-chart
              [data]="timeOfDayBreakdownData"
              [categories]="timeOfDayBreakdownLabels"
            />
          </app-analytics-widget>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="loading"
            class="h-full w-full"
          >
            <app-analytics-apex-chart-pie
              [series]="carrierData"
              [labels]="carrierLabels"
              [title]="timeOfDayBreakdownTitleProvider"
              [manualColors]="carrierColors"
            />
          </app-analytics-widget>
        </mat-grid-tile>
      </mat-grid-list>
    } @else {
      <div
        class="no-charts-container flex h-72 flex-col items-center justify-center"
      >
        <div
          class="no-charts-icon h-64 w-64 bg-happy-face bg-center bg-no-repeat"
        ></div>
        <p class="no-charts-text mb-8 mt-4 text-2xl text-seagreen-500">
          No QoE problems found in this time range
        </p>
      </div>
    }

    @if ((qoeRawDeviceEvents$ | async)?.devices.length && !isLoadingData) {
      <app-qoe-data-table
        [deviceEvents]="(qoeRawDeviceEvents$ | async)?.devices"
        [isLoading]="isLoadingData"
        [isNoContent]="isNoContent"
      ></app-qoe-data-table>
    } @else {
      <div
        class="flex h-full flex-col items-center justify-center rounded-xl bg-white p-12 shadow-sm"
      >
        <p class="my-4 text-xl text-seagreen-500">
          No devices found for the selected time range.
        </p>
      </div>
    }
  </div>
</section>
